// src/redux/actions/cityActions.js
import {
	FETCH_GETINSTITUTE_REQUEST,
	FETCH_GETINSTITUTE_SUCCESS,
	FETCH_GETINSTITUTE_FAILURE,
	SET_SELECTED_GETINSTITUTE,
} from '../types';
import axios from '../../API/axios';

export const fetchInstituteData = (searchTerm = '') => async (dispatch) => {
	dispatch({ type: FETCH_GETINSTITUTE_REQUEST });

	try {
		const response = await axios.get(`/MasterData/GetRegdInstitutesDDL?Search=${searchTerm}`);
		// const response = await axios.get(`/MasterData/GetInstitutesDDL?Search=${searchTerm}`);
		// console.log('Search :', response);
		let getinstituteList = response.data.responseData.map((val) => {
			return {
				value: val.id,
				label: val.name,
				tag: val.tagID
			}
		})
		dispatch({
			type: FETCH_GETINSTITUTE_SUCCESS,
			payload: getinstituteList,
		});
	} catch (error) {
		dispatch({
			type: FETCH_GETINSTITUTE_FAILURE,
			payload: error.message,
		});
	}
};

export const selectGetInstitute = (getinstituteId) => ({
	type: SET_SELECTED_GETINSTITUTE,
	payload: getinstituteId,
});
